// extracted by mini-css-extract-plugin
export var card = "card-module--card--a2074";
export var cardContent = "card-module--cardContent--b7195";
export var cardDescription = "card-module--cardDescription--2088d";
export var cardImage = "card-module--cardImage--37071";
export var cardImageAboutUs = "card-module--cardImageAboutUs--0f1cb";
export var cardReadMore = "card-module--cardReadMore--30d06";
export var cardTitle = "card-module--cardTitle--d473a";
export var content = "card-module--content--f9f1b";
export var dateSection = "card-module--dateSection--3fb20";
export var evidenceBased = "card-module--evidenceBased--85199";
export var genericContainer = "card-module--genericContainer--8343e";
export var reviewdBySection = "card-module--reviewdBySection--77105";
export var reviewedBy = "card-module--reviewedBy--947b0";
export var reviewedOn = "card-module--reviewedOn--d4f7f";
export var reviewer = "card-module--reviewer--899c7";
export var shortBio = "card-module--shortBio--12311";
export var singleTypeContent = "card-module--singleTypeContent--f309f";
export var writtenBySection = "card-module--writtenBySection--78b10";